import React, { useEffect, useState } from 'react'
import { Button } from '../Payment/styles'
import config from '../../config'
import Cookies from 'js-cookie'
import axios from 'axios'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, convertToRaw, convertFromHTML, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import Swal from 'sweetalert2'
import './styles.css'

const EditPolicy = () => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  useEffect(() => {
    const getPolicy = async () => {
      try {
        const response = await axios.get(`${config.apiAdminGateway}/api/v1/admin/consent`, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
          params: {
            type: 'Privacy',
            isRequired: 'TRUE',
            isPublic: 'TRUE',
          },
        })

        if (response.data.status.code !== 0) throw new Error(response.data.status.message)

        setEditorState(
          EditorState.createWithContent(
            ContentState.createFromBlockArray(convertFromHTML(response.data.data[0].content)),
          ),
        )
      } catch (error) {
        console.log(error)
      }
    }
    getPolicy()
  }, [])

  const handleSaveButtonClick = async () => {
    await Swal.fire({
      title: 'คุณต้องการปรับเปลี่ยนนโยบายและเงื่อนไขใช่หรือไม่?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่',
      cancelButtonText: 'ไม่',

      preConfirm: async () => {
        try {
          const content = draftToHtml(convertToRaw(editorState.getCurrentContent()))

          const response = await axios.post(
            `${config.apiAdminGateway}/api/v1/admin/consent`,
            {
              type: 'Privacy',
              title: 'นโยบายและเงื่อนไข',
              content: content,
              acceptLabel: 'นโยบายและเงื่อนไข',
              priority: 1,
              isRequired: true,
              isPublic: true,
            },
            {
              headers: {
                Authorization: `Bearer ${Cookies.get('accessToken')}`,
              },
            },
          )

          if (response.data.status.code !== 0) {
            throw new Error(response.data.status.message)
          }
        } catch (error) {
          Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการปรับเปลี่ยนนโยบายและเงื่อนไข')
          return false
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'เปลี่ยนเรียบร้อย!',
          icon: 'success',
        })
      }
    })
    return true
  }

  return (
    <div className="Container">
      <header className="Container-header">แก้ไข นโยบายและเงื่อนไข</header>
      <Editor
        toolbar={{
          options: ['inline', 'list', 'textAlign', 'link', 'history', 'fontFamily'],
          inline: {
            options: ['bold', 'italic', 'underline'],
          },
          fontFamily: {
            options: ['Anuphan'],
          },
          textAlign: {
            options: ['left', 'center', 'right', 'justify'],
          },
        }}
        editorState={editorState}
        onEditorStateChange={setEditorState}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        stripPastedStyles={true}
        handlePastedText={() => false}
      />

      <Button active onClick={handleSaveButtonClick}>
        ยืนยัน
      </Button>
    </div>
  )
}

export default EditPolicy
